import { useInstantSearch } from 'react-instantsearch';
import styles from './Results.module.css';

const Results = (props: { totalResults?: number }) => {
  const { results, status } = useInstantSearch();
  const { totalResults } = props;
  const isSearchStalled = status === 'stalled';
  return (
    <div className={styles.wrapper}>
      <span className={styles.total}>
        {isSearchStalled && <>Searching&hellip;</>}
        {!isSearchStalled &&
          `Showing ${results.nbHits}${totalResults ? ` of ${totalResults}` : ''} networks`}
      </span>
    </div>
  );
};

export default Results;
